'use strict';
module.exports = {
    exportDatepicker: function () {
        $(document).ready(function () {
            $('.js-datepicker').datepicker(
                {
                    disableTouchKeyboard: true,
                    autoclose: true,
                    language: $('html').attr('lang') && $('html').attr('lang').trim().length > 0 ? $('html').attr('lang') : 'en'
                }
            );
        });
    }
};
